import { createFileRoute } from "@tanstack/react-router";

import { Page } from "@/components/Page";
import { ButtonLink } from "@/components/ui/button";
import { H1, P } from "@/components/ui/typography";
import { getAccountDetailsQueryOptions } from "@/lib/api";

export const Route = createFileRoute(
  "/app/_sidebar-layout/create-connected-account/complete",
)({
  component: HomeComponent,
  loader: ({ context: { queryClient } }) => {
    void Promise.all([
      queryClient.prefetchQuery(getAccountDetailsQueryOptions()),
    ]);
  },
  head: () => ({ meta: [{ title: "Monetization Complete" }] }),
});

function HomeComponent() {
  return (
    <Page>
      <div className="max-w-[600px] w-full mx-auto flex flex-col gap-8 bg-slate-subtle p-8 border border-slate-7 dark:border-slatedark-7 rounded-lg">
        <div className="flex gap-4 justify-between">
          <H1>Account Connected!</H1>
        </div>

        <div className="flex flex-col gap-2">
          <P>You've successfully connected your account for monetization!</P>
        </div>
        <ButtonLink to="/app/account">Go to Account Settings</ButtonLink>
      </div>
    </Page>
  );
}
